import type { Manifest } from './base/Field'
import HyModel from './base/Model'

// Validation
import { required } from './base/Validation'

export default class CompanyUpdateRequest extends HyModel {
  override options() {
    return {
      saveUnchanged: true,
      patch: false,
      remoteModel: 'CompanyUpdate'
    }
  }

  override manifest(): Manifest {
    return {
      reporting_period: {
        type: 'select',
        options: {
          items: () => this.reportingPeriodOptions
        }
      },
      custom_message: {
        type: 'switch',
        label: 'Use custom message'
      },
      subject: {},
      message: {
        type: 'text'
      },
      type: {
        validation: required
      },
      report_frequency: {},
      company_slug: {}
    }
  }

  override actions() {
    return {
      create: {
        method: 'POST',
        route: 'companies/{company_slug}/company_updates'
      }
    }
  }

  get reportingPeriodOptions() {
    if (this.get('report_frequency') === 'monthly') {
      // Return a list of the last 12 months
      const months = []
      const now = new Date()
      for (let i = 0; i < 12; i++) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 0, 23, 59, 59)
        months.push(date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }))
      }
      return months
    } else if (this.get('report_frequency') === 'quarterly') {
      // Return a list of the last 4 quarters
      const quarters = []
      const now = new Date()
      const previousQuarter = new Date(now.getFullYear(), now.getMonth() - 2, 0, 23, 59, 59)
      for (let i = 0; i < 4; i++) {
        const date = new Date(previousQuarter.getFullYear(), previousQuarter.getMonth() - i * 3, 15, 23, 59, 59)
        // Format the date as Q1 2025, Q2 2025, etc.
        const month = date.getMonth() + 1
        const quarter = Math.ceil(month / 3)
        const year = date.getFullYear()
        const label = `Q${quarter} ${year}`
        quarters.push(label)
      }
      return quarters
    } else {
      return []
    }
  }

  get defaultReportingPeriod() {
    return this.reportingPeriodOptions[0]
  }
}
